export default __webpack_public_path__ + "static/media/Elettric80.3338e727.png";